import React from "react";
import "./SelectionBar.css";

/** Нижняя панель шага мастера: «Назад», сводка выбора и «Продолжить» */
function SelectionBar({
  children,
  onBack,
  onContinue,
  continueDisabled,
  continueLabel = "Продолжить",
}) {
  return (
    <div className="al-selection-bar">
      <div className="al-selection-bar__info">
        {onBack && (
          <button
            type="button"
            className="oj-btn oj-btn--secondary al-selection-bar__back"
            onClick={onBack}
          >
            Назад
          </button>
        )}
        {children}
      </div>
      <button
        type="button"
        className="oj-btn oj-btn--primary al-continue"
        disabled={continueDisabled}
        onClick={onContinue}
      >
        {continueLabel}
      </button>
    </div>
  );
}

export const SelectionStat = ({ label, value }) => (
  <span className="al-selection-bar__stat">
    {label} <strong>{value}</strong>
  </span>
);

export default SelectionBar;
